var map = {
	"./": 1352,
	"./Clutch": 2651,
	"./Clutch.js": 2651,
	"./NewUi": 2652,
	"./NewUi.js": 2652,
	"./OldUi": 2653,
	"./OldUi.js": 2653,
	"./index": 1352,
	"./index.js": 1352,
	"./style": 849,
	"./style.js": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4168;